export const FluxConversions = (function () {
  var fluxConversions = {}

  // private constants
  const BOLTZMANN = 1.38e-23 * 1.0e26 // [Jy/K]
  // const PLANCK = 6.626e-34 // [J s]
  const LIGHTSPEED = 2.99792458e8 // [m/s]
  const BEAMSIZE_FACTOR = 1.13
  const GIGAHERTZ_TO_HERTZ = 1.0e9
  const RAD_TO_ARCSEC = 648000 / Math.PI
  const BRIGHTNESS_FACTOR = Math.log(2.0)
  const DISH_DIAMETER_M = 12

  // round numbers using exp trick to avoid small rounding weirdness
  // due to JS FP arithmetic
  fluxConversions.round = function round (value, places) {
    return Number(Math.round(value + 'e' + places) + 'e-' + places)
  }

  fluxConversions.toFluxSensitivity = function (tempInK, frequencyGHz, beamArc) {
    if (beamArc === 0) {
      return Infinity
    }
    let wavelengthM = LIGHTSPEED / (frequencyGHz * GIGAHERTZ_TO_HERTZ)
    let angle = Math.PI * beamArc / 3600.0 / 180.0
    let omega = Math.PI * angle * angle / 4 / Math.log(2.0)
    let result = tempInK * omega * 2 * BOLTZMANN / (wavelengthM * wavelengthM)
    return result
  }

  fluxConversions.toBrightnessTemp = function (sensitivityJy, frequencyGHz, beamArcsec) {
    if (beamArcsec === 0) {
      return Infinity
    }
    let wavelengthM = LIGHTSPEED / (frequencyGHz * GIGAHERTZ_TO_HERTZ)
    let result = (sensitivityJy * wavelengthM * wavelengthM) / (2 * BOLTZMANN)
    let angle = Math.PI * beamArcsec / 3600.0 / 180.0
    let omega = Math.PI * angle * angle / 4 / BRIGHTNESS_FACTOR
    result /= omega
    return fluxConversions.round(result, 6)
  }

  fluxConversions.calculateBeamsize = function (frequencyInGHz) {
    if (frequencyInGHz <= 0) {
      return 0
    }
    let freqInHz = frequencyInGHz * GIGAHERTZ_TO_HERTZ
    let wavelength = LIGHTSPEED / freqInHz
    let v = BEAMSIZE_FACTOR * wavelength / DISH_DIAMETER_M
    let beamsize = v * RAD_TO_ARCSEC

    return fluxConversions.round(beamsize, 1)
  }

  return fluxConversions
}())
